import { formatPercent } from '@/lib/format'
import type { AddonSetting, BillingAddon } from '../types'

/** What `addon` charges this month, as a percentage: 0% when it is off. */
export function formatAddonPercent(
  addons: AddonSetting[],
  addon: BillingAddon
): string {
  const on = addons.find((setting) => setting.addon === addon)
  return formatPercent(on ? Number(on.fraction) : 0)
}
